import { Navigate, useLocation } from "react-router-dom";
import { getAccessRules } from "../constants/accessRules";
import Auth from "../utils/AuthUtils";

const RoleProtectedRoute = ({ children }) => {
  const location = useLocation();

  const role = Auth.getUserDetails("roles");

  const access = getAccessRules(role, "");
  const allowedRoutes = access.routes;

  const currentPath = location.pathname;

  const isAllowed = matchPathWithRules(allowedRoutes, currentPath);

  if (!isAllowed) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

const pathToRegex = (path) => {
  const regexString = path
    .replace(/:\w+/g, "[^/]+") // Replace dynamic params like :id
    .replace(/\//g, "\\/"); // Escape slashes
  return new RegExp(`^${regexString}(\\/)?$`);
};

const matchPathWithRules = (allowedRoutes, currentPath) => {
  for (const pattern of allowedRoutes) {
    const regex = pathToRegex(pattern);
    if (regex.test(currentPath)) {
      return true;
    }
  }
  return false;
};

export default RoleProtectedRoute;
